var map = {
	"./": "./src/api/schemas/index.js",
	"./address": "./src/api/schemas/address.js",
	"./address.js": "./src/api/schemas/address.js",
	"./addressTimezone": "./src/api/schemas/addressTimezone.js",
	"./addressTimezone.js": "./src/api/schemas/addressTimezone.js",
	"./agency": "./src/api/schemas/agency.js",
	"./agency.js": "./src/api/schemas/agency.js",
	"./agencyAccountBranch": "./src/api/schemas/agencyAccountBranch.js",
	"./agencyAccountBranch.js": "./src/api/schemas/agencyAccountBranch.js",
	"./agencyAccountDetail": "./src/api/schemas/agencyAccountDetail.js",
	"./agencyAccountDetail.js": "./src/api/schemas/agencyAccountDetail.js",
	"./agencyAllocationWorker": "./src/api/schemas/agencyAllocationWorker.js",
	"./agencyAllocationWorker.js": "./src/api/schemas/agencyAllocationWorker.js",
	"./agencyShift": "./src/api/schemas/agencyShift.js",
	"./agencyShift.js": "./src/api/schemas/agencyShift.js",
	"./agencyShiftAssignment": "./src/api/schemas/agencyShiftAssignment.js",
	"./agencyShiftAssignment.js": "./src/api/schemas/agencyShiftAssignment.js",
	"./approveListing": "./src/api/schemas/approveListing.js",
	"./approveListing.js": "./src/api/schemas/approveListing.js",
	"./area": "./src/api/schemas/area.js",
	"./area.js": "./src/api/schemas/area.js",
	"./bulkMessage": "./src/api/schemas/bulkMessage.js",
	"./bulkMessage.js": "./src/api/schemas/bulkMessage.js",
	"./bulkOffer": "./src/api/schemas/bulkOffer.js",
	"./bulkOffer.js": "./src/api/schemas/bulkOffer.js",
	"./bureauResourcesCompany": "./src/api/schemas/bureauResourcesCompany.js",
	"./bureauResourcesCompany.js": "./src/api/schemas/bureauResourcesCompany.js",
	"./country": "./src/api/schemas/country.js",
	"./country.js": "./src/api/schemas/country.js",
	"./dashboard": "./src/api/schemas/dashboard.js",
	"./dashboard.js": "./src/api/schemas/dashboard.js",
	"./employer": "./src/api/schemas/employer.js",
	"./employer.js": "./src/api/schemas/employer.js",
	"./employerAccount": "./src/api/schemas/employerAccount.js",
	"./employerAccount.js": "./src/api/schemas/employerAccount.js",
	"./employerAccountInvitation": "./src/api/schemas/employerAccountInvitation.js",
	"./employerAccountInvitation.js": "./src/api/schemas/employerAccountInvitation.js",
	"./employerBulkBreak": "./src/api/schemas/employerBulkBreak.js",
	"./employerBulkBreak.js": "./src/api/schemas/employerBulkBreak.js",
	"./index": "./src/api/schemas/index.js",
	"./index.js": "./src/api/schemas/index.js",
	"./index.test": "./src/api/schemas/index.test.js",
	"./index.test.js": "./src/api/schemas/index.test.js",
	"./industry": "./src/api/schemas/industry.js",
	"./industry.js": "./src/api/schemas/industry.js",
	"./internalWorkerInvitation": "./src/api/schemas/internalWorkerInvitation.js",
	"./internalWorkerInvitation.js": "./src/api/schemas/internalWorkerInvitation.js",
	"./job": "./src/api/schemas/job.js",
	"./job.js": "./src/api/schemas/job.js",
	"./jobCandidate": "./src/api/schemas/jobCandidate.js",
	"./jobCandidate.js": "./src/api/schemas/jobCandidate.js",
	"./lightVenues": "./src/api/schemas/lightVenues.js",
	"./lightVenues.js": "./src/api/schemas/lightVenues.js",
	"./listing": "./src/api/schemas/listing.js",
	"./listing.js": "./src/api/schemas/listing.js",
	"./listingOffer": "./src/api/schemas/listingOffer.js",
	"./listingOffer.js": "./src/api/schemas/listingOffer.js",
	"./listingOverview": "./src/api/schemas/listingOverview.js",
	"./listingOverview.js": "./src/api/schemas/listingOverview.js",
	"./listingPayRate": "./src/api/schemas/listingPayRate.js",
	"./listingPayRate.js": "./src/api/schemas/listingPayRate.js",
	"./listingTemplate": "./src/api/schemas/listingTemplate.js",
	"./listingTemplate.js": "./src/api/schemas/listingTemplate.js",
	"./message": "./src/api/schemas/message.js",
	"./message.js": "./src/api/schemas/message.js",
	"./multiple_booking": "./src/api/schemas/multiple_booking.js",
	"./multiple_booking.js": "./src/api/schemas/multiple_booking.js",
	"./noShowReason": "./src/api/schemas/noShowReason.js",
	"./noShowReason.js": "./src/api/schemas/noShowReason.js",
	"./nonSyftExperience": "./src/api/schemas/nonSyftExperience.js",
	"./nonSyftExperience.js": "./src/api/schemas/nonSyftExperience.js",
	"./payRate": "./src/api/schemas/payRate.js",
	"./payRate.js": "./src/api/schemas/payRate.js",
	"./permission": "./src/api/schemas/permission.js",
	"./permission.js": "./src/api/schemas/permission.js",
	"./reason": "./src/api/schemas/reason.js",
	"./reason.js": "./src/api/schemas/reason.js",
	"./report": "./src/api/schemas/report.js",
	"./report.js": "./src/api/schemas/report.js",
	"./reportType": "./src/api/schemas/reportType.js",
	"./reportType.js": "./src/api/schemas/reportType.js",
	"./role": "./src/api/schemas/role.js",
	"./role.js": "./src/api/schemas/role.js",
	"./shift": "./src/api/schemas/shift.js",
	"./shift.js": "./src/api/schemas/shift.js",
	"./skill": "./src/api/schemas/skill.js",
	"./skill.js": "./src/api/schemas/skill.js",
	"./timesheet": "./src/api/schemas/timesheet.js",
	"./timesheet.js": "./src/api/schemas/timesheet.js",
	"./types": "./src/api/schemas/types.ts",
	"./types.ts": "./src/api/schemas/types.ts",
	"./uniform": "./src/api/schemas/uniform.js",
	"./uniform.js": "./src/api/schemas/uniform.js",
	"./user": "./src/api/schemas/user.js",
	"./user.js": "./src/api/schemas/user.js",
	"./venue": "./src/api/schemas/venue.js",
	"./venue.js": "./src/api/schemas/venue.js",
	"./worker": "./src/api/schemas/worker.js",
	"./worker.js": "./src/api/schemas/worker.js",
	"./workerRole": "./src/api/schemas/workerRole.js",
	"./workerRole.js": "./src/api/schemas/workerRole.js",
	"./workerVenue": "./src/api/schemas/workerVenue.js",
	"./workerVenue.js": "./src/api/schemas/workerVenue.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api/schemas sync recursive ^\\.\\/.*$";